"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidSemverXyz = isValidSemverXyz;
const SEMVER_XYZ = /^\d+\.\d+\.\d+$/;
function isValidSemverXyz(version) {
  return SEMVER_XYZ.test(version);
}
//# sourceMappingURL=semver.util.js.map